var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTruckBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 115.39 251.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #25cbf2;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #637079;\n      }\n\n      .cls-3 {\n        fill: #3b464e;\n      }\n\n      .cls-4 {\n        fill: #222b32;\n      }\n\n      .cls-5 {\n        fill: #d32f2f;\n      }\n\n      .cls-6 {\n        fill: #cad6dd;\n      }\n\n      .cls-7 {\n        fill: #d8e2e7;\n      }\n\n      .cls-8 {\n        fill: #e1eaef;\n      }\n\n      .cls-9 {\n        fill: #bec9d2;\n      }\n\n      .cls-10 {\n        fill: #e4edf1;\n      }\n\n      .cls-11 {\n        fill: #00b3e6;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m32.78,114.22h49.83c1.93,0,3.5,1.57,3.5,3.5h0c0,1.93-1.57,3.5-3.5,3.5h-49.83c-1.93,0-3.5-1.57-3.5-3.5h0c0-1.93,1.57-3.5,3.5-3.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 32.01,
    y: 111.34,
    width: 51.37,
    height: 9.89,
    transform: "translate(115.39 232.56) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 37.22,
    y: 111.34,
    width: 40.95,
    height: 9.89,
    transform: "translate(115.39 232.56) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m42.59,113.59h30.21c1.48,0,2.68,1.2,2.68,2.68h0c0,1.48-1.2,2.68-2.68,2.68h-30.21c-1.48,0-2.68-1.2-2.68-2.68h0c0-1.48,1.2-2.68,2.68-2.68Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m95.55,19.09H19.85c-4.1,0-6.58-4.52-4.39-7.99C19.05,5.41,25.39,1.63,32.62,1.63h.27v11.65h49.61V1.63h.27c7.23,0,13.58,3.78,17.17,9.47,2.19,3.47-.29,7.99-4.39,7.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m33.58,3.78h48.23c10.77,0,19.51,8.74,19.51,19.51v77.78c0,5.96-4.84,10.79-10.79,10.79H24.86c-5.96,0-10.79-4.84-10.79-10.79V23.29c0-10.77,8.74-19.51,19.51-19.51Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 57.7,
    cy: 36.42,
    r: 28.13
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m36.5,38.11h42.38c9.69,0,17.55,7.87,17.55,17.55v14.83H18.95v-14.83c0-9.69,7.87-17.55,17.55-17.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m34,56.53h47.39c8.33,0,15.09,6.76,15.09,15.09v23.45c0,5.96-4.84,10.79-10.79,10.79H29.7c-5.96,0-10.79-4.84-10.79-10.79v-23.45c0-8.33,6.76-15.09,15.09-15.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m35.02,0h45.35c1.47,0,2.67,1.2,2.67,2.67v1.11h-50.69v-1.11c0-1.47,1.2-2.67,2.67-2.67Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m1.33,54.16h9.47c.74,0,1.33.6,1.33,1.33v.99c0,.74-.6,1.33-1.33,1.33H1.33c-.74,0-1.33-.6-1.33-1.33v-.99c0-.74.6-1.33,1.33-1.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m16.3,52.47H7.42c-.75,0-1.36.61-1.36,1.36h0c0,.75.61,1.36,1.36,1.36h8.87c.75,0,1.36-.61,1.36-1.36h0c0-.75-.61-1.36-1.36-1.36Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 103.26,
    y: 54.16,
    width: 12.14,
    height: 3.66,
    rx: 1.33,
    ry: 1.33,
    transform: "translate(218.65 111.98) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m99.09,52.47h8.87c.75,0,1.36.61,1.36,1.36h0c0,.75-.61,1.36-1.36,1.36h-8.87c-.75,0-1.36-.61-1.36-1.36h0c0-.75.61-1.36,1.36-1.36Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m30.74,101.56h0c-1.48,0-2.67-1.2-2.67-2.67v-27.88c0-1.48,1.2-2.67,2.67-2.67h0c1.48,0,2.67,1.2,2.67,2.67v27.88c0,1.48-1.2,2.67-2.67,2.67Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 37.05,
    y: 68.33,
    width: 5.34,
    height: 33.22,
    rx: 2.67,
    ry: 2.67
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m48.71,101.56h0c-1.48,0-2.67-1.2-2.67-2.67v-27.88c0-1.48,1.2-2.67,2.67-2.67h0c1.48,0,2.67,1.2,2.67,2.67v27.88c0,1.48-1.2,2.67-2.67,2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m57.7,101.56h0c-1.48,0-2.67-1.2-2.67-2.67v-27.88c0-1.48,1.2-2.67,2.67-2.67h0c1.48,0,2.67,1.2,2.67,2.67v27.88c0,1.48-1.2,2.67-2.67,2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m66.68,101.56h0c-1.48,0-2.67-1.2-2.67-2.67v-27.88c0-1.48,1.2-2.67,2.67-2.67h0c1.48,0,2.67,1.2,2.67,2.67v27.88c0,1.48-1.2,2.67-2.67,2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m75.67,101.56h0c-1.48,0-2.67-1.2-2.67-2.67v-27.88c0-1.48,1.2-2.67,2.67-2.67h0c1.48,0,2.67,1.2,2.67,2.67v27.88c0,1.48-1.2,2.67-2.67,2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m84.65,101.56h0c-1.48,0-2.67-1.2-2.67-2.67v-27.88c0-1.48,1.2-2.67,2.67-2.67h0c1.48,0,2.67,1.2,2.67,2.67v27.88c0,1.48-1.2,2.67-2.67,2.67Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 9.16,
    y: 77.61,
    width: 97.08,
    height: 173.7,
    rx: 15.4,
    ry: 15.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 14.64,
    y: 83.57,
    width: 86.11,
    height: 161.77,
    rx: 14,
    ry: 14
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m86.39,218.07H29.01c-1.4,0-2.54-1.14-2.54-2.54h0c0-1.4,1.14-2.54,2.54-2.54h57.38c1.4,0,2.54,1.14,2.54,2.54h0c0,1.4-1.14,2.54-2.54,2.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m86.39,208.6H29.01c-1.4,0-2.54-1.14-2.54-2.54h0c0-1.4,1.14-2.54,2.54-2.54h57.38c1.4,0,2.54,1.14,2.54,2.54h0c0,1.4-1.14,2.54-2.54,2.54Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m86.39,169.37H29.01c-1.4,0-2.54-1.14-2.54-2.54h0c0-1.4,1.14-2.54,2.54-2.54h57.38c1.4,0,2.54,1.14,2.54,2.54h0c0,1.4-1.14,2.54-2.54,2.54Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 26.47,
    y: 154.83,
    width: 62.46,
    height: 5.07,
    rx: 2.54,
    ry: 2.54
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m86.39,120.67H29.01c-1.4,0-2.54-1.14-2.54-2.54h0c0-1.4,1.14-2.54,2.54-2.54h57.38c1.4,0,2.54,1.14,2.54,2.54h0c0,1.4-1.14,2.54-2.54,2.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m86.39,111.2H29.01c-1.4,0-2.54-1.14-2.54-2.54h0c0-1.4,1.14-2.54,2.54-2.54h57.38c1.4,0,2.54,1.14,2.54,2.54h0c0,1.4-1.14,2.54-2.54,2.54Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckBlue);
export default __webpack_public_path__ + "static/media/truck_blue.7340f213e80441b00b62b1a91465dd99.svg";
export { ForwardRef as ReactComponent };